import auth from './auth';
import courses from './courses';
import quiz from './quiz';

/**
 * Object containing various services.
 * @type {any}
 */
export const services = {
  auth,
  courses,
  quiz,
};
